import React from 'react'

export default function Footer() {
    return (
        <footer className="footer">
            <span>Copyright  &copy;  {`${new Date().getFullYear()}`} <span
                className="font-weight-semibold">{`SAS MIMTECH`}</span> All rights reserved.</span>


            <div>
                <a className="text-gray" href="/docs/CGU.pdf" target={"_blank"}>Conditions générales d'utilisation</a>
                <span className="mx-2 text-muted"> | </span>
                <a className="text-gray" href="/docs/Politique-de-Confidentialité.pdf" target={"_blank"}>Politique de confidentialité</a>
            </div>
        </footer>
    )
}

